/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentEntities} from '../api'

 export const useQueryGetInvestmentEntities = createReactQueryHook('getInvestmentEntities', getInvestmentEntities)
